<!----------------------- Компонент для реєстрації --------------------->
<template>
  <div class="enterReg">
    <div class="reg">
      <div class="header-login" v-if="$route.query.hasOwnProperty('from-link')">
        <headloginreg @clickLogo="devMode()" />
        <!-- Мова -->
        <div class="langSelector">
          <!-- <SelectLangs @changeLang="changeLang($event)" /> -->
          <LangSelectComponent @changeLang="changeLang($event)" />
        </div>
      </div>
      <div @click="goLogin" class="go-login">
        <svg class="go-login-icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
          viewBox="0 0 451.847 451.847">
          <path fill="#000" d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
    c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
    c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z" />
        </svg>
        <span class="go-login-link">{{ lang['login'] }}</span>
      </div>
      <div class="reg-scroll">
        <div class="form-reg">
          <div class="special">
          </div>
          <!--
                    при реєстрації, нам спочатку необхідно дізнатися номер користувача
                -->
          <div class="form-block">
            <label for="person_login_input_regiter" class="phone-text">{{ lang['Phone'] }}</label>
            <div class="inputPlus">
              <b-form-input class="form-reg_input" type="text" v-model="form.phone" name="login"
                id="person_login_input_regiter" :state="phoneState" @input="inputEdit" />
              <span class="plus">+</span>
            </div>
            <span v-if="!isValidPhoneFormat" class="red-span">
              {{ lang['enterCorrectNumber'] }}
            </span>

            <label class="custom-checkbox" for="agreement-check">
              <input class="checkbox" type="checkbox" id="agreement-check" v-model="acceptPrivacyPolicy">
              <span class="fake-checkbox"
                :style="isValidPrivacyPolicyFormat === false ? { border: '1px solid red' } : {}">
                <svg class="checkbox-icon" width="11" height="8" viewBox="0 0 13 10" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.1875 5.875L4.25 8.9375L11.25 1.9375" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
              <span class="span-agree">{{ lang['regAgree'] }}
                <a class="privacy-policy-term" href="/privacy-policy">
                  <span>{{ lang['PrivacyPolicy'] }}</span>
                </a><span class="span-and">, </span>
                <a class="privacy-policy-term" href="/terms-of-use">
                  <span>{{ lang['TermOfUse'] }}</span>
                </a><span class="span-and">, </span>
                <a class="privacy-policy-term" href="/cookie-policy">
                  <span>{{ currentLang === 'ru' ? 'Политику Cookies' : currentLang === 'uk' ? 'Політику Cookies' : 'Cookie Policy' }}</span>
                </a> <span class="span-and">{{ lang['and'] }} </span>
                <a class="privacy-policy-term" href="/dpa">
                  <span>{{ currentLang === 'ru' ? 'DPA' : currentLang === 'uk' ? 'DPA' : 'DPA' }}</span>
                </a>
              </span>
            </label>
            <button class="btn btn-success" @click="validPhoneFormat">{{ lang['Registration'] }}</button>
          </div>
          <confirmCountry v-if="showConfirmCountry" :country="country" @close="closeCountry()" @n="no" @y="sendPhone" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import confirmCountry from "@/components/registration/confirmCountry.vue"; // Компонент для підтвердження країни
import headloginreg from '../heads/HeaderLoginAndReg.vue'; // Компонент хедеру з логотипом
import { store } from '@/store.js' // Глобальне сховище даних
import { regAPi } from '@/API.js';
import Cookies from 'js-cookie'; // Модуль для роботи з кукі
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import LangSelectComponent from "../LangSelectComponent.vue";

// создаем апи куков с настройкой дэфолтного домен для продакшена
let apiCookies = Cookies;
if (process.env.NODE_ENV == 'production') {
  apiCookies = Cookies.withAttributes({ domain: ".skyservice.online" })
}
const apiList = new regAPi();
export default {
  components: {
    headloginreg,
    confirmCountry,
    LangSelectComponent
  },
  data() {
    return {
      form: {
        phone: '',
        email: ''
      },
      showConfirmCountry: false,
      isValidPhoneFormat: true,
      isValidPrivacyPolicyFormat: undefined,
      acceptPrivacyPolicy: true,
      country: null
    }
  },

  watch: {
    acceptPrivacyPolicy(newVal) {
      if (newVal === true) {
        this.isValidPrivacyPolicyFormat = true
      }
    }
  },

  created() {
    const inParams = new URLSearchParams(location.search);

    // Берем email який передали з іншого місця в URL
    try {
      const accountEmail = inParams.get('email');
      if (accountEmail) {
        this.form.email = accountEmail;
      }
    } catch (err) {
      console.error(err);
    }
    // Берем номер телефону який передали з іншого місця в URL
    try {
      const accountPhone = inParams.get('phone');
      if (accountPhone) {
        this.form.phone = accountPhone.replace('+', '');
      }
    } catch (err) {
      console.error(err);
    }

    if (Cookies.get('token')) {
      document.location.href = "https://cabinet.skyservice.online";
    }

    keyevent.$off('enter');
    keyevent.$on('enter', () => {
      this.validPhoneFormat();
    });
  },
  methods: {
    // Закриває вікно вибору країни та переналаштовує обробку натискання клавіші Enter
    closeCountry() {
      keyevent.$off('enter')
      keyevent.$on('enter', () => this.validPhoneFormat())
      this.showConfirmCountry = false
    },
    // Зміна мови
    changeLang(l) {
      localStorage.setItem("lang_user", l);
      store.lang = l;
      window.lang = store.langs[store.lang]();
    },
    // Очищає номер телефону від символу "+" і позначає його як валідний
    inputEdit() {
      const str = this.form.phone
      this.form.phone = str.replace('+', '');
      this.isValidPhoneFormat = true
    },
    // Скидає статус валідності телефону і приховує вікно підтвердження країни
    no() {
      this.isValidPhoneFormat = false;
      this.showConfirmCountry = false;
    },
    validPhoneFormat() {
      this.isValidPrivacyPolicyFormat = this.acceptPrivacyPolicy
      if (this.phoneState && this.isValidPrivacyPolicyFormat) {
        try {
          //Костыльчик для Украины что бы не вводить +38
          if (this.form.phone["0"] == "0") {
            this.form.phone = "38" + this.form.phone
          }
        } catch (err) {
          console.error(err)
        }
        const obj = {
          phone: this.form.phone,
          ref_id: localStorage.getItem('ref_id') != null ? localStorage.getItem('ref_id') : ''
        }
        apiList.phoneFormatValidation(obj).then((resp) => {
          console.log(resp);
          if (resp.data.status === "done") {
            if (resp.data.data.viewModal) {
              this.country = resp.data.data.country;
              this.showConfirmCountry = true;
            } else {
              this.sendPhone();
            }
          } else {
            this.isValidPhoneFormat = false;
          }
        });
      } else {
        if (!this.phoneState) {
          window.say.messageError(this.lang['WrongFormat'])
        }
        else {
          window.say.messageError(this.lang['AcceptTheTerms'])
        }
      }
    },
    // відправки телефону
    sendPhone() {
      this.showConfirmCountry = false
      try {
        const obj = {
          phone: this.form.phone,
          lang: store.lang,
          email: this.form.email,
          ref_id: localStorage.getItem('ref_id') != null ? localStorage.getItem('ref_id') : ''
        }
        apiList.quickRegistration(obj).then(resp => {
          if (resp.data.status == 'done') {
            localStorage.setItem('user_login', this.form.phone);
            window.say.message(this.lang['Saved']);
            apiCookies.set("token", resp.data.data.token, { expires: 180 });//, {domain: ".skyservice.online"}
            document.location.href = "https://cabinet.skyservice.online/";
          }
          else {
            this.form.phone = '';
            window.say.messageError(this.lang['PhoneAlreadyRegistered']);
          }
        })
        // } else {
        //     window.say.messageError(this.lang['WrongFormat'])
        // }
      } catch (err) {
        // console.log(err)
      }
    },
    // Просто перехід на сторінку логіна
    goLogin() {
      this.$router.push('/login')
    },
  },
  computed: {
    // Мова додатку
    // lang() {
    //   return window.lang;
    // },
    lang() {
      return store.langs[store.lang]();
    },
    phoneState() {
      return (this.form.phone && this.form.phone.length >= 4 && !isNaN(this.form.phone)) ? true : false;
    }
  }
}
</script>

<style scoped>
.enterReg {
  position: relative;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.reg {
  width: 100%;
  margin: 15px 20px;
}

.phone-text {
  font-size: 15px;
  margin-bottom: 15px;
}

label {
  margin-bottom: 0;
}

input {
  margin-bottom: 0 !important;
}

.inputPlus {
  position: relative;
  margin-bottom: 25px;
}

.form-control.is-valid:focus {
  border-color: #00c279;
}

/* --------------NEW STYLES--------------- */

.custom-checkbox {
  cursor: pointer;
  display: flex;
  flex-flow: row;
  gap: 14px;
  margin-bottom: 25px;
}

.custom-checkbox input {
  display: none;
}

.fake-checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 17px;
  height: 17px;
  border: 1px solid #00c279;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  margin-top: 3px;
}

.checkbox-icon {
  display: none;
  stroke: white;
}

.custom-checkbox input:checked+.fake-checkbox {
  border: none;
  background-color: #00C279;
}

.custom-checkbox input:checked+.fake-checkbox .checkbox-icon {
  display: block;
}

.span-agree {
  color: black;
  font-size: 14px;
}

.span-and {
  color: black;
  font-size: 14px;
  text-transform: lowercase;
}

.privacy-policy-term {
  color: #007bff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.btn {
  width: 100%;
  height: 45px;
  /* margin-bottom: 2rem; */
  /* margin-bottom: 50px; */
  border: none;
  color: white;
  font-weight: 500;
}

.btn-success {
  background-color: #00c279;
  border: none;
}

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

/* .btn-success { */
/* width: 100%; */
/* margin-bottom: 2rem; */
/* margin-top: 1rem;
  margin-bottom: 50px; */
/* } */

.red-span {
  display: block;
  font-size: 14px;
  color: red;
  margin-bottom: 15px;
  margin-top: -10px;
}

.form-block {
  padding: 9 15px;
}

.go-login {
  color: black;
  cursor: pointer;
  font-size: 15px;
  margin-bottom: 30px;
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 5px;
}

.go-login-icon {
  transform: rotate(90deg);
}

.go-login-link {
  margin-top: 1px;
}

/* .go-login-link:hover {
  color: #00B26F;
  text-decoration: underline;
} */

.chevron {
  color: #106090;
  margin-right: 3px
}

.description {
  /* font-size: small; */
}

.special {
  position: absolute;
  left: -10px;
  top: -2px;
  cursor: pointer;
}

.plus {
  position: absolute;
  font-size: 20px;
  bottom: 0;
  top: 0;
  display: flex;
  align-items: center;
  left: 10px;
  color: #495057;
}

input.form-reg_input {
  /* margin-bottom: 15px; */
  height: 45px;
  padding-left: 1.5rem;
}

.reg-block-container {
  padding: 15px;
}

.form-reg,
.network-reg {
  position: relative;
  /* padding: 15px; */
  /* margin-bottom: 1rem; */
}

.reg-scroll {
  /* height: calc(100vh - 70px); */
  overflow: auto;
}

@media screen and (max-width: 700px) {
  .reg-block-container {
    padding: 0;
  }

  /* .form-reg {
    padding: 15px 5px;
    margin-bottom: 3rem;
  } */
}

#footerLinks {
  margin-left: 2rem;
  position: absolute;
  bottom: 20px;
  font-size: 9pt;
}

@media screen and (max-height: 510px) {
  #footerLinks {
    position: relative;
    margin-top: 2rem;
  }
}

@media screen and (min-width: 576px) {
  .reg {
    max-width: 536px;
  }
}

@media screen and (min-width: 768px) {
  .enterReg {
    background:
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' transform='rotate(-30 7 8)' viewBox='0 0 14 16' width='50'%3E%3Cpath fill='%23eee' d='M.377 13.484h8.466c1.374 0 1.439-1.092 1.439-1.596 0-.586-.152-1.257-1.483-1.655L2.776 8.41c-.239-.063-1.199-.377-1.81-1.091C.268 6.521.181 5.369.181 4.55c0-.881.109-1.95.981-2.727.785-.711 1.768-.818 2.51-.818h8.792v2.203H4.653c-.392 0-.851.021-1.199.336-.371.335-.392.859-.392 1.132 0 .651.196 1.279 1.417 1.657l5.585 1.699c1.024.315 1.724.63 2.181 1.048.917.839 1.004 2.141 1.004 2.831 0 .923-.131 1.952-.763 2.729-.764.943-1.724 1.047-2.727 1.047H.377v-2.203z'/%3E%3C/svg%3E"),
      linear-gradient(184deg, rgb(211, 211, 211) 0%, rgb(240, 240, 240) 80%);
    background-repeat: repeat;
    background-size: cover;
    background-position: center, center;
    align-items: center;
  }

  .reg {
    max-width: 430px;
    padding: 30px;
    border-radius: 12px;
    background-color: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .form-reg_input {
    height: auto;
  }

  .btn {
    height: auto;
  }
}
</style>